import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { HamButtonComponent } from '@modeso/aumico-components';
import { SubjectType } from '../../enums/subject-type.enum';

/**
 * REV-22155 — filter "Typ" (Firma / Person) of the tasks page, next to "Status" and in the same look.
 *
 * Own component instead of reusing `status-filter-drop-down`, which is typed to task states. Pure view:
 * the selection is edited on a copy and reported on "Anwenden" / "Zurücksetzen".
 */
@Component({
    selector: 'subject-type-filter-drop-down',
    templateUrl: './subject-type-filter-drop-down.component.html',
    styleUrls: ['../status-filter-drop-down/status-filter-drop-down.component.scss'],
})
export class SubjectTypeFilterDropDown implements OnChanges {
    @Input() selectedTypes: SubjectType[] = [];
    @Input() rightAlignment = false;
    @Output() typeChange = new EventEmitter<SubjectType[]>();

    readonly options = [
        { labelKey: 'aumico_pm_tasks_type_company', value: SubjectType.COMPANY },
        { labelKey: 'aumico_pm_tasks_type_person', value: SubjectType.PERSON },
    ];

    draft: SubjectType[] = [];
    openedFlyout = false;
    flyoutPosition: { top: number; left: number; right: number } = { top: 0, left: 0, right: 0 };

    get isFilterActive(): boolean {
        return this.selectedTypes.length > 0;
    }

    ngOnChanges(): void {
        this.draft = [...this.selectedTypes];
    }

    toggle(value: SubjectType): void {
        this.draft = this.draft.includes(value) ? this.draft.filter((v) => v !== value) : [...this.draft, value];
    }

    openFlyout(button: HamButtonComponent): void {
        const rect = button.nativeButton?.nativeElement?.getBoundingClientRect();
        if (!rect) {
            return;
        }
        this.draft = [...this.selectedTypes];
        this.flyoutPosition = {
            top: rect.bottom + 8,
            right: rect.right,
            left: this.rightAlignment ? rect.left - (rect.right - rect.left) : rect.left,
        };
        this.openedFlyout = true;
    }

    closeFlyout(): void {
        this.openedFlyout = false;
    }

    applyFilter(): void {
        this.closeFlyout();
        this.typeChange.emit([...this.draft]);
    }

    clearFilter(): void {
        this.draft = [];
        this.closeFlyout();
        this.typeChange.emit([]);
    }
}
